import request from '@/tools/request';
import { Notification } from 'element-ui';
import taskOverdueMsg from '@/page/project-record/components/task-overdue-msg.vue';
import createExtend from '@C/createExtend';

import Vue from 'vue';

// 获得 任务记录列表
export const getList = {
  root: false,
  handler: async ({ state, commit, rootState }, params) => {
    return new Promise(resolve => {
      const {
        homeProject: { id: projectId, type, projectType }
      } = rootState;
      if (!projectId || !type || !projectType) return;

      const query = {
        ...state.tableSearchQuery,
        ...state.pageQuery,
        projectId,
        type,
        isSelected: 1,
        ...params
      };
      commit('SET_TABLE_LOADING', true);
      // 用户标签 字符串形式
      // if (query.userTag && Array.isArray(query.userTag)) {
      //   if (query.userTag.includes('未设置')) {
      //     query.notSet = 1;
      //   }
      //   query.userTag = query.userTag.join(',');
      // }
      query.notSet = query.userTag == '未设置' ? 1 : 0;
      request
        .post('/rest/cso/saas/taskOverdue/overdueList', query)
        .then(res => {
          const {
            data: {
              data: { list, total, selectedSize, maxSelectedSize }
            }
          } = res;

          // 在返回数据中 加入 请求时的 一些参数 比如 type 字段，type在任务列表点击查看 详情接口 需要
          let result = list.map(i => {
            return {
              ...i,
              type: type
            };
          });
          commit('SET_TABLE_DATA', result);
          commit('SET_SELECTED_SIZE', selectedSize);
          commit('SET_MAX_SELECTED_SIZE', maxSelectedSize);
          commit('SET_PAGE_TOTAL', total);

          // 缓存结果 的搜索条件，用来做结果选择
          commit('SET_TABLE_DATARESPOND_QUERY', query);

          commit('SET_TABLE_LOADING', false);
          resolve({ list: result, total, selectedSize, query });

          commit('SET_TABLE_LOADING', false);
        });
    });
  }
};
// 结果全选，注意：接口要带选择搜索后的搜索条件
export const selectAll = {
  root: false,
  handler: async ({ state, rootState, dispatch }, isSelected) => {
    const {
      dataAnalysis: {
        projectDetail: { projectId, type }
      }
    } = rootState;
    const q = {
      ...state.pageQuery,
      projectId,
      type,
      ...state.tableDataRespondQuery,
      isSelected: isSelected ? 1 : 0
    };

    // 用户标签 字符串形式
    if (q.userTag && Array.isArray(q.userTag)) {
      if (q.userTag.includes('未设置')) {
        q.notSet = 1;
      }
      q.userTag = q.userTag.join(',');
    }

    const {
      data: { code }
    } = await request.post('/rest/cso/saas/taskOverdue/taskRecordListAll', q, {
      serviceLoading: true
    });
    if (+code === 1) {
      return dispatch('getList', q);
    }
  }
};

// 批量过期
export const batchOverdue = {
  root: false,
  handler: async ({ state, rootState, commit }) => {
    return new Promise((resolve, reject) => {
      const {
        dataAnalysis: {
          projectDetail: { projectId, projectType }
        }
      } = rootState;
      let content = `<p>你正在操作任务过期，本次过期任务数 <span style='color:#027cfa'>${state.selectedSize}</span> 条，请谨慎处理，任务过期后将无法恢复</p>`;
      if (+projectType === 6) {
        content = '';
      }

      const overdueDialog = createExtend(taskOverdueMsg, {
        content,
        projectType,
        projectId,
        source: 1
      });
      overdueDialog.$on('confirm', redisKeyUv => {
        const query = {
          projectId,
          redisKeyUv
        };
        // 展示 loading
        const loading = Vue.prototype.$loading({
          lock: true,
          text: `0 / ${state.selectedSize}`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // 轮询进度
        state.queryCountTimer = setInterval(async () => {
          const {
            data: { data }
          } = await request.post(
            ' /rest/cso/saas/taskOverdue/auditTaskOverdueList/all/queryCount',
            {
              projectId: projectId,
              source: 1 //1任务记录 2 快捷审核
            }
          );
          loading.setText(`${data} / ${state.selectedSize}`);
        }, 500);
        request
          .post('/rest/cso/saas/taskOverdue/auditTaskOverdueList/all', query, {
            serviceLoading: true
          })
          .then(res => {
            const {
              data: { code, data, message }
            } = res;
            if (+code === 1) {
              Notification({
                title: data,
                message: message,
                type: 'success'
              });
              resolve();
            } else {
              Notification({
                title: data,
                message: message,
                type: 'error'
              });
              reject();
            }
          })
          .finally(() => {
            loading.setText(`${state.selectedSize} / ${state.selectedSize}`);
            commit('CLEAR_QUERY_COUNT_TIMER');
            loading.close();
            overdueDialog.remove();
          });
      });
    });
  }
};
